import h from 'virtual-dom/h'
import { settings } from "../../../../settings/settings-util";
import objectPath from 'object-path'
import { hideTimeoutWarningAction } from "../actions/actions";
import { sendRequest } from '../../../lib-alme-request/src/lib-alme-request';
import { resetSessionId,
    clearHistoryInState,
    clearHistoryInAgent,
    addNotificationMessage,
    showTimeoutWarning,
    hideTimeoutWarning,
    setSessionStartTime,
    refreshPersistedState,
    setInactivityTime} from '../../../lib-end-session/lib/lib-end-session'
import * as Actions from '../actions/actions';
import {enableInputBox, disableInputBox, SendRequestAndReEnableInputBox} from '../../../lib-inputbox-toggle/lib/lib-inputbox-toggle';

export default class Renderer
{
    //#region Public Interface

    constructor(settings)
    {
        this._settings = settings;
        this.resetSessionId = resetSessionId;
        this.clearHistoryInState = clearHistoryInState;
        this.clearHistoryInAgent = clearHistoryInAgent;
        this.addNotificationMessage = addNotificationMessage;
        this.hideTimeoutWarning = hideTimeoutWarning;
        this.setSessionStartTime = setSessionStartTime;
        this.showTimeoutWarning = showTimeoutWarning;
        this.refreshPersistedState = refreshPersistedState;
        this.setInactivityTime = setInactivityTime;
    }

    initialize(store)
    {
        this._store = store;
    }

    getRender()
    {
        return () =>
        {   
            let shadowClassName = this._settings.classNames.timeoutWarningShadow || settings.classNames.timeoutWarningShadow;
            let windowLocation = this._settings.stateLocations.Window.Base;
            let timeoutLocation = this._settings.stateLocations.TimeoutWarning.Base;
            let timeoutVisibleLocation = this._settings.stateLocations.TimeoutWarning.Visible;

            return h("div", {
                className: shadowClassName,
                style: {
                    display: this._store.getState()[windowLocation][timeoutLocation][timeoutVisibleLocation] ? 'block' : 'none'
                }
            }, [this.buildWarning()]);
        };
    }

    removeAriaHidden()
    {
        let concersationareaelement = document.getElementsByClassName(`${this._settings.classNames.conversationAreaClassName}`);
        if (concersationareaelement.length > 0) { 
            concersationareaelement[0].removeAttribute('aria-hidden');
        }
        let uidragclass = 'ui-draggable-handle';
        let headerelement = document.getElementsByClassName(`${this._settings.classNames.headerClassName}`);
        let headerelementwithdrag = document.getElementsByClassName(`${this._settings.classNames.headerClassName} ${uidragclass}`);
        if (headerelement.length > 0) {
            headerelement[0].removeAttribute('aria-hidden');
        }
        else if (headerelementwithdrag.length > 0) {
            headerelementwithdrag[0].removeAttribute('aria-hidden')
        }
    }

    //#endregion



    //#region Builder Methods

    buildWarning()
    {
        let warningClassName = this._settings.classNames.timeoutWarning || settings.classNames.timeoutWarning;
        let padClassName = this._settings.classNames.timeoutWarningPad || settings.classNames.timeoutWarningPad;
        let textId = this._settings.elementIds.timeoutWarningTextId || settings.elementIds.timeoutWarningTextId;

        let children =
        [
            this.buildText(),
            this.buildButtonWrapper()
        ];

        let warningAttributes =
        {
            className: warningClassName,
            attributes: {
              role: 'dialog',
              'aria-labelledby': textId,
              'aria-modal': true
            }
        };

        let warning = h("div", warningAttributes, children);
        return h("div", { className: padClassName }, [warning]);
    }

    buildText()
    {
        let textClass = this._settings.classNames.timeoutWarningText || settings.classNames.timeoutWarningText;
        let textId = this._settings.elementIds.timeoutWarningTextId || settings.elementIds.timeoutWarningTextId;
        let text = this._settings.textConstants.timeoutWarningText || settings.textConstants.timeoutWarningText;

        return h("span", { className: textClass, id: textId }, [text]);
    }

    buildButtonWrapper()
    {
        let buttonWrapClass = this._settings.classNames.timeoutWarningButtonWrap || settings.classNames.timeoutWarningButtonWrap;

        return h("div", { className: buttonWrapClass }, [this.buildYesButton(), this.buildNoButton()])
    }

    buildYesButton()
    {   const buildYesOnClick = this.buildYesOnClick.bind(this);
        let className = this._settings.classNames.timeoutWarningYesButton || settings.classNames.timeoutWarningYesButton;
        let title = this._settings.textConstants.timeoutWarningYesTitle || settings.textConstants.timeoutWarningYesTitle;
        let properties =
        {
            className: className,
            onclick: () => {buildYesOnClick()}
        };

        return h("button", properties, title)
    }

    buildNoButton()
    {   
        const buildNoOnClick = this.buildNoOnClick.bind(this);
        let visibleLocation = `${this._settings.stateLocations.Window.TimeoutWarning.Base}.${this._settings.stateLocations.Window.TimeoutWarning.Visible}`;
        let className = this._settings.classNames.timeoutWarningNoButton || settings.classNames.timeoutWarningNoButton;
        let title = this._settings.textConstants.timeoutWarningNoTitle || settings.textConstants.timeoutWarningNoTitle;
        let properties =
        {
            className: className,
            onclick: () => {buildNoOnClick()}
        };

        return h("button", properties, title)
    }

    buildNoOnClick()
    {   
        disableInputBox(this._store, this._settings, () => true);
        this.resetSessionId(this._store, this._settings);
        this.clearHistoryInState(this._store, this._settings);
        this.clearHistoryInAgent(this._settings);
        this.addNotificationMessage(this._store, this._settings);
        this.hideTimeoutWarning(this._store, this._settings);
        this.setSessionStartTime("", this._store, this._settings);
        this.removeAriaHidden();  
        enableInputBox(this._store, this._settings, () => true);
    }

    buildMinimizeOnClick()
    {
        
            const { IsMinimized } = this._settings.stateLocations.Window;
            const { reportingEventRequest } = this._settings.messageConstants;

            this._store?.dispatch(Actions.setMinimize(true, IsMinimized));

            const input = {
                eventName: 'MinimizedClicked',
                eventValue: true,
                messageType: reportingEventRequest,
            };

            sendRequest(input);

            return false;
        
    }

    buildYesOnClick()
    {
        const conversationBase = this._settings.stateLocations.Conversation.Base;
        const visibleLocation = `${this._settings.stateLocations.Window.TimeoutWarning.Base}.${this._settings.stateLocations.Window.TimeoutWarning.Visible}`;
        const userId = this._settings.stateLocations.Conversation.userId;
        const sessionId = this._settings.stateLocations.Conversation.sessionId;
        const channel = this._settings.stateLocations.Conversation.channel;
        const eventName = this._settings.timeoutWarning.reportingEventName || settings.timeoutWarning.reportingEventName;
        const messageType = this._settings.messageConstants.reportingEventRequest;
        this.removeAriaHidden();
        const input =
        {
            messageType: messageType,
            userID: objectPath.get(this._store.getState(), `${conversationBase}.${userId}`),
            sessionID: objectPath.get(this._store.getState(), `${conversationBase}.${sessionId}`),
            channel: objectPath.get(this._store.getState(), `${conversationBase}.${channel}`),
            eventName: eventName,
            eventValue: eventName,
        };

        this._store.dispatch(hideTimeoutWarningAction(visibleLocation));
        disableInputBox(this._store, this._settings, () => true);
        SendRequestAndReEnableInputBox(input, this._store, this._settings)
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/timeout-warning-overlay/src/renderers/renderer.js